import React from 'react';

const CampaignSaleFormModal = React.lazy(() => import('../components/FormModal'));
const campaignSaleModalRegistry = {
    crm_campaignSaleId: CampaignSaleFormModal
};
export default campaignSaleModalRegistry;
